import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HashRouter } from 'react-router-dom';
import { Text } from '@mantine/core';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
      <Footer />
    </HashRouter>
  </React.StrictMode>
);

function Footer() {
  return (
    <Text align="center" size="xs" pt='1.5em'>
      &copy; COLLABO STYLE INC.
    </Text>
  );
}

